
































































import { Component, Vue } from 'vue-property-decorator'
import UpsertWidgetModal from './UpsertWidgetSetting.vue'
import NotFound from '@/components/common/NotFound.vue'
import { WidgetModel } from '@/_models/WidgetModel'

@Component({
  components: {
    NotFound,
  },
})
export default class ListWidgetSetting extends Vue {
  public pageFilters: any = {
    currentPage: 1,
    perPage: 10,
  }

  dragging: { index?: number; row?: any } = {}

  get isLoading() {
    return this.$store.getters['settings/settingLoading']
  }

  get widgetSettingsData() {
    return this.$store.state.settings.widgets
  }

  public tableSortSettings: [string, string] = ['order', 'asc']

  public handleOpenModalUpsert(widgetData?: WidgetModel) {
    this.$buefy.modal.open({
      parent: this,
      component: UpsertWidgetModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        formData: widgetData,
      },
    })
  }

  public confirmSingleDelete(id: string) {
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        await this.processDelete(id)
      },
    })
  }

  public async processDelete(id: string) {
    return this.$store.dispatch('settings/deleteOneWidget', id).then(() => {
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  created() {
    this.$store.dispatch('floors/getAll')
  }
}
